export const NONE = "NONE";
export const RESERVE = "RESERVE";
export const COMPLETE_QUOTA = "COMPLETE_QUOTA";


// WEBPACK FOOTER //
// ./src/constants/draftSaleOrderPaymentTypeConst.js